export const SECTION = 'Section';
export const SECTION_ADD = 'Section_add';
export const SECTION_DELETE = 'Section_deleted';
export const SECTION_EDIT = 'Section_edit';

export const SECTION_SETROWDATA = 'Section_set_rowdata';
export const MODEL_OPEN = 'Section_model_open';
export const MODEL_CLOSE = 'Section_model_close';

export const SECTION_LIST_SUCCESSFUL = 'Section_list_successfull';
export const SECTION_ADD_SUCCESSFUL = 'Section_add_successfull';
export const SECTION_EDIT_SUCCESSFUL = 'Section_edit_successfull';

export const API_ERROR = 'api_failed';
